// constants/property/propertyConstants.js

export const PROPERTY_TYPES = [
  {
    value: "apartment",
    label: "Căn hộ / Chung cư",
  },
  {
    value: "villa",
    label: "Biệt thự",
  },
  {
    value: "shophouse",
    label: "Shophouse",
  },
  {
    value: "condotel",
    label: "Condotel",
  },
  {
    value: "penthouse",
    label: "Penthouse",
  },
  {
    value: "duplex",
    label: "Duplex",
  },
];

export const TRANSACTION_TYPES = [
  {
    value: "sale",
    label: "Bán",
  },
  {
    value: "rent",
    label: "Cho thuê",
  },
];

export const PROPERTY_AMENITIES = [
  "Hồ bơi",
  "Gym",
  "Khu vui chơi",
  "Bảo vệ 24/7",
  "Bãi đỗ xe",
  "Thang máy",
  "Sân vườn",
  "BBQ",
  "Trung tâm thương mại",
  "Công viên",
  "Trường học",
];

export const FURNITURE_OPTIONS = [
  {
    value: "none",
    label: "Trống",
  },
  {
    value: "basic",
    label: "Cơ bản",
  },
  {
    value: "full",
    label: "Đầy đủ",
  },
];

export const HANDOVER_OPTIONS = [
  {
    value: "raw",
    label: "Thô",
  },
  {
    value: "basic",
    label: "Hoàn thiện cơ bản",
  },
  {
    value: "furnished",
    label: "Hoàn thiện nội thất",
  },
];

export const PROPERTY_STATUS_OPTIONS = [
  {
    value: "pending",
    label: "Chờ duyệt",
  },
  {
    value: "approved",
    label: "Đã duyệt",
  },
  {
    value: "rejected",
    label: "Từ chối",
  },
];

export const PROPERTY_STATUS_MAP = {
    pending: {
      label: "Chờ duyệt",
      className: "text-yellow-600",
    },
  
    approved: {
      label: "Đã duyệt",
      className: "text-green-600",
    },
  
    rejected: {
      label: "Từ chối",
      className: "text-red-600",
    },
  };

  export const PROPERTY_INITIAL_FORM = {
    projectId: "",
    projectName: "",
  
    title: "",
  
    propertyType: "apartment",
    transactionType: "sale",
  
    price: "",
    rentPrice: "",
  
    block: "",
    unitCode: "",
    floor: "",
  
    bedrooms: 0,
    bathrooms: 0,
  
    area: "",
  
    furniture: "none",
    handoverStatus: "raw",
  
    status: "pending",
  
    isSold: false,
  
    location: "",
  
    amenities: [],
  
    description: "",
  
    images: [],
  };